import { ref, inject, provide } from 'vue';
export const HoverContextKey = Symbol('HoverContextProps');
export const useProvideHover = (props) => {
    provide(HoverContextKey, props);
};
export const useInjectHover = () => {
    return inject(HoverContextKey, {
        startRow: ref(-1),
        endRow: ref(-1),
        onHover() { },
    });
};
